module.exports = __webpack_public_path__ + "static/assets/78cd8e2c774b858b4e49077d0b1b391d.png";